import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Loader from "../components/Loader";
import "./AdminPage.css";

const AdminPage = ({ companyId }) => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/survey/company/${companyId}`);
        setSurveys(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchSurveys();
  }, [companyId]);

  const handleSurveyClick = (surveyId) => {
    navigate(`/admin/survey/${surveyId}`);
  };

  if (loading) return <Loader text="Loading Surveys..." />;

  return (
    <div className="admin-page-container">
      <h1 className="admin-title">Available Surveys</h1>
      {surveys.length === 0 ? (
        <p className="no-survey-text">No surveys available for your company.</p>
      ) : (
        <div className="survey-grid">
          {surveys.map((survey) => (
            <div
              key={survey.id}
              className="survey-card"
              onClick={() => handleSurveyClick(survey.id)}
            >
              <h3>{survey.name}</h3>
              <p>{survey.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminPage;
